module.exports = __webpack_public_path__ + "static/img/contect_6.3d358836.jpg";